import { EntityKeyConfig } from '../../../types/entities';

/**
 * Entity Keys for NOTES
 * 
 * Defines the key structure used throughout the application
 * for this entity type.
 */
export const keys: EntityKeyConfig = {
  single: 'note',
  plural: 'notes',
  state: 'notes'
};
